<!--
Author: TangChen
Date: 2018-09-05
Desc: 登录后页面组件，由router.js 配置引入
-->
<template>
    <div class="view-frame view">
        <header-com />
        <menu-con />
        <el-container class="home-box">
            <el-main>
                <router-view />
                <log />
            </el-main>
        </el-container>
        <footer-com />
    </div>
</template>

<script>
import headerCom from "@/components/common/header.vue";
import footerCom from "@/components/common/footer.vue";
import menuCon from "@/components/common/menu.vue";
import log from "@/components/common/log.vue";
export default {
    components: {
        headerCom,
        footerCom,
        menuCon,
        log
    },
    data () {
        return {
            url: ""
        };
    },
    created(){
    },
    methods: {
    }
};
</script>
<style lang="scss">
    .view-frame {
        min-height: 500px;
        .home-box {
            width: 1200px;
            margin: 10px auto 0;
            .menu-nav {
                overflow: hidden;
                margin-right: 14px;
            }
            .el-main {
                min-height: 400px;
                padding: 0;
                .view:first-child {
                    margin-top: 0;
                }
            }
        }
    }
</style>
